import { normalize_text, to_number } from './view_case_details_core_helpers';

const STATUS_ID_QUERY_FIELDS = [
  'assigned_form_status_id',
  'assignedFormStatusId',
  'current_status_id',
  'currentStatusId',
  'status_id',
  'statusId',
];
const STATUS_NAME_QUERY_FIELDS = ['status', 'status_name', 'statusName'];
const STATUS_ID_FIELDS = ['id', 'status_id'];

function first_present(values = []) {
  return values.find((value) => value !== undefined && value !== null && value !== '');
}

function first_query_value(query = {}, fields = []) {
  return first_present(fields.map((field) => query?.[field]));
}

function normalized_status_name(value = '') {
  return normalize_text(value).toLowerCase();
}

function status_ids(status = {}) {
  return STATUS_ID_FIELDS.map((field) => to_number(status?.[field])).filter(Boolean);
}

function status_id_matches(status = {}, status_id = null) {
  return Boolean(status_id && status_ids(status).includes(to_number(status_id)));
}

function status_name_matches(status = {}, status_name = '') {
  return Boolean(status_name && normalized_status_name(status?.name) === status_name);
}

export function reassign_status_filter(query = {}) {
  return {
    status_id: to_number(first_query_value(query, STATUS_ID_QUERY_FIELDS)),
    status_name: normalized_status_name(first_query_value(query, STATUS_NAME_QUERY_FIELDS)),
  };
}

export function status_matches_reassign_filter(status = {}, filter = {}) {
  const has_filter = Boolean(filter.status_id || filter.status_name);
  return !has_filter
    || status_id_matches(status, filter.status_id)
    || status_name_matches(status, filter.status_name);
}
